module.exports = __webpack_public_path__ + "static/key-vampirethemasquerade-33fbf77a7b4b74e3fed61a99f26b4c8a.webp";